import { UUISuggestionsTheme } from '../../../types/UUISuggestions'

const suggestionsTheme: UUISuggestionsTheme = {
  options: (/*{ size }*/) => {
    const baseClassNames = [
      'tw:font-ubuntu tw:font-normal tw:z-1000 tw:overflow-hidden tw:flex tw:flex-col tw:justify-center tw:items-start',
      'tw:rounded-[20px] tw:[box-shadow:0_0_15px_4px_rgba(0,0,0,0.05)] tw:bg-grey-1000',
      'tw:[width:var(--uui-suggestions-anchor-width)] tw:[max-height:var(--uui-suggestions-available-height)]'
    ]
    return baseClassNames.join(' ')
  },

  option: ({ highlighted, disabled, size }) => {
    const baseClassNames = [
      'tw:text-left tw:w-full tw:font-ubuntu tw:font-normal tw:box-border tw:whitespace-normal tw:break-words tw:break-normal   tw:wrap-anywhere',
      disabled ? 'tw:text-grey-600 tw:cursor-default' : 'tw:text-primary-text tw:cursor-pointer',
      highlighted ? 'tw:bg-aquamarine-50' : 'tw:bg-transparent',
      'tw:hover:bg-grey-800'
    ]
    const sizeClassNames = []
    switch (size) {
      case 'small':
        sizeClassNames.push('tw:py-[4px] tw:pr-[12px] tw:pl-[16px] tw:text-[12px] tw:leading-[16px]')
        break
      case 'large':
        sizeClassNames.push('tw:py-[8px] tw:pr-[12px] tw:pl-[16px] tw:text-[16px] tw:leading-[24px]')
        break
      case 'normal':
      default:
        sizeClassNames.push('tw:py-[6px] tw:pr-[12px] tw:pl-[16px] tw:text-[14px] tw:leading-[20px]')
        break
    }
    return [baseClassNames.join(' '), sizeClassNames.join(' ')].join(' ')
  }
}

export default suggestionsTheme
